var $dcmfp$loadscript2 = require("load-script2");


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "init", function () { return $39cbbfca55176c03$export$2cd8252107eb640b; });
$parcel$export(module.exports, "default", function () { return $39cbbfca55176c03$export$2e2bcd8739ae039; });
/// <reference path="decs.d.ts" />

const $39cbbfca55176c03$var$TRUV_BRIDGE_URL = "https://cdn.truv.com/bridge.js";
let $39cbbfca55176c03$var$bridge = null;
const $39cbbfca55176c03$var$tryLoadScriptOneTime = async ()=>{
    await (0, ($parcel$interopDefault($dcmfp$loadscript2)))($39cbbfca55176c03$var$TRUV_BRIDGE_URL);
    $39cbbfca55176c03$var$bridge ??= window.TruvBridge ?? null;
};
let $39cbbfca55176c03$var$bridgePromise = $39cbbfca55176c03$var$tryLoadScriptOneTime();
const $39cbbfca55176c03$var$getBridge = async ()=>{
    if ($39cbbfca55176c03$var$bridge) return $39cbbfca55176c03$var$bridge;
    try {
        const initialBridgePromise = $39cbbfca55176c03$var$bridgePromise;
        try {
            // Wait for last attempt to load the script
            await initialBridgePromise;
        } catch  {}
        if (!$39cbbfca55176c03$var$bridge) {
            // Make another attempt to load the script if it was not loaded
            if (initialBridgePromise === $39cbbfca55176c03$var$bridgePromise) // If other init call has already started loading the script (changed bridgePromise instance), do not start another one
            $39cbbfca55176c03$var$bridgePromise = $39cbbfca55176c03$var$tryLoadScriptOneTime();
            await $39cbbfca55176c03$var$bridgePromise;
        }
        if (!$39cbbfca55176c03$var$bridge) throw "TruvBridge is not initialized";
        return $39cbbfca55176c03$var$bridge;
    } catch (error) {
        console.error("Error loading Truv Bridge", error);
        throw error;
    }
};
const $39cbbfca55176c03$export$2cd8252107eb640b = (bridgeConfig)=>{
    let state = {
        isLoaded: false,
        needOpen: false
    };
    $39cbbfca55176c03$var$getBridge().then((bridge)=>{
        const prevState = state;
        if (prevState.isLoaded) // It is impossible to get here
        return;
        state = {
            isLoaded: true,
            bridgeInstance: bridge.init(bridgeConfig)
        };
        if (prevState.needOpen) state.bridgeInstance.open();
    });
    return {
        open: ()=>{
            if (state.isLoaded) state.bridgeInstance.open();
            else state.needOpen = true;
        },
        close: ()=>{
            if (state.isLoaded) state.bridgeInstance.close();
            else state.needOpen = false;
        }
    };
};
var $39cbbfca55176c03$export$2e2bcd8739ae039 = {
    init: $39cbbfca55176c03$export$2cd8252107eb640b
};


//# sourceMappingURL=index.js.map
